<template>
  <!-- AI-assisted 2026-09 START: VTEC Add On selection -->
  <section v-if="items.length" class="add-on">
    <div class="add-on-title">
      <span>{{ $t('details.addOn') }}</span>
      <span class="add-on-optional">{{ $t('details.optional') }}</span>
    </div>
    <q-list class="add-on-list">
      <q-item v-for="item in items" :key="item.externalProductId" class="add-on-item">
        <q-item-section avatar class="add-on-checkbox-section">
          <q-checkbox
            v-model="selectedIds"
            :val="item.externalProductId"
            :disable="item.available === false"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label class="add-on-name">{{ item.name }}</q-item-label>
          <q-item-label caption class="add-on-price">
            {{ $pid(item.unitPrice) }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </section>
  <!-- AI-assisted 2026-09 END: VTEC Add On selection -->
</template>

<script>
// AI-assisted 2026-09 START: VTEC Add On selection
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedIds: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
// AI-assisted 2026-09 END: VTEC Add On selection
</script>

<style lang="scss" scoped>
/* AI-assisted 2026-09 START: VTEC Add On selection */
.add-on {
  background: #fff;

  &-title {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 12px 16px;
    background: $grayBg;
    color: $black;
    font-size: 16px;
    font-weight: bold;
  }

  &-optional {
    padding: 1px 4px;
    border: 1px solid $border;
    border-radius: 3px;
    color: $grayFont;
    font-size: 12px;
    font-weight: normal;
  }

  &-list {
    padding: 6px 0;
  }

  &-item {
    min-height: 52px;
    padding: 8px 16px;
  }

  &-checkbox-section {
    min-width: 32px;
    padding-right: 8px;
  }

  &-name {
    color: $black;
    font-size: 14px;
  }

  &-price {
    color: $grayFont;
    font-size: 12px;
  }
}
/* AI-assisted 2026-09 END: VTEC Add On selection */
</style>
